/* Factory Store — Búsqueda predictiva (oct 2026).
   Se engancha a los buscadores propios del tema (header desktop, buscador fijo
   móvil y el del menú móvil) y muestra, mientras se escribe, sugerencias de
   búsqueda, colecciones/marcas y productos con foto y precio.
   Usa la API nativa de Shopify /search/suggest.json (sin apps). Los enlaces de
   producto conservan los parámetros _psq/_pos para las estadísticas de búsqueda. */
(function () {
  if (window.__fsPredictive) return;
  window.__fsPredictive = true;

  var SELECTOR = '.factory-wh-search__input, #fs-msearch input[name=q], .fsd-search input[name=q]';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};

  var css = [
    '.fs-ps{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:1000;background:#fff;color:#0d0d0d;border:1px solid #dcdcd6;border-radius:10px;box-shadow:0 14px 40px rgba(0,0,0,.16);max-height:min(72vh,620px);overflow:auto;overscroll-behavior:contain;text-align:left;font-size:14px;line-height:1.3;}',
    '.fs-ps[hidden]{display:none;}',
    '.fs-ps__h{font-family:var(--fs-font-mono,monospace);font-size:10.5px;letter-spacing:.08em;text-transform:uppercase;color:#5e5e58;padding:12px 14px 6px;}',
    '.fs-ps__chips{display:flex;flex-wrap:wrap;gap:6px;padding:2px 14px 8px;}',
    '.fs-ps__chip{display:inline-flex;align-items:center;gap:6px;padding:7px 11px;border:1px solid #dcdcd6;border-radius:999px;color:#0d0d0d;text-decoration:none;font-size:13px;background:#fff;}',
    '.fs-ps__chip b{font-weight:800;}',
    '.fs-ps__prod{display:grid;grid-template-columns:52px 1fr auto;gap:12px;align-items:center;padding:8px 14px;color:#0d0d0d;text-decoration:none;}',
    '.fs-ps__img{width:52px;height:52px;border:1px solid #ecece7;border-radius:6px;background:#fff;object-fit:contain;}',
    '.fs-ps__v{display:block;font-family:var(--fs-font-mono,monospace);font-size:10px;letter-spacing:.06em;text-transform:uppercase;color:#ff5b0a;margin-bottom:2px;}',
    '.fs-ps__t{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:13.5px;}',
    '.fs-ps__t mark{background:none;color:inherit;font-weight:800;}',
    '.fs-ps__p{text-align:right;white-space:nowrap;font-weight:800;font-size:14px;}',
    '.fs-ps__p s{display:block;font-weight:400;font-size:11.5px;color:#5e5e58;}',
    '.fs-ps__p em{display:inline-block;font-style:normal;font-size:10.5px;font-weight:800;background:#ff5b0a;color:#0d0d0d;border-radius:4px;padding:1px 5px;margin-left:4px;}',
    '.fs-ps__out{display:block;font-size:11px;font-weight:600;color:#5e5e58;}',
    '.fs-ps__all{display:flex;justify-content:space-between;align-items:center;gap:8px;margin:6px 10px 10px;padding:12px 14px;border-radius:8px;background:#0d0d0d;color:#fff;text-decoration:none;font-weight:700;}',
    '.fs-ps__empty{padding:16px 14px;color:#5e5e58;}',
    '.fs-ps__empty a{color:#0d0d0d;font-weight:700;}',
    '.fs-ps [data-fs-ps-item].is-active,.fs-ps .fs-ps__prod:hover{background:#f6f6f3;}',
    '.fs-ps .fs-ps__chip.is-active,.fs-ps .fs-ps__chip:hover{border-color:#0d0d0d;background:#f6f6f3;}',
    '.fs-ps .fs-ps__all.is-active,.fs-ps .fs-ps__all:hover{background:#ff5b0a;color:#0d0d0d;}',
    '.fs-ps-host{position:relative;overflow:visible!important;}',
    /* Botón para borrar lo escrito de un toque (reemplaza la X nativa del navegador) */
    '.fs-ps-host input[type=search]::-webkit-search-cancel-button{-webkit-appearance:none;appearance:none;display:none;}',
    '.fs-ps-clear{flex:0 0 auto;align-self:center;display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;margin:0 2px;padding:0;border:0;background:none;color:#0d0d0d;cursor:pointer;-webkit-tap-highlight-color:transparent;}',
    '.fs-ps-clear[hidden]{display:none;}',
    '.fs-ps-clear span{display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:#e6e6e0;}',
    '.fs-ps-clear:hover span,.fs-ps-clear:focus-visible span{background:#0d0d0d;color:#fff;}',
    '.fs-ps-clear svg{width:10px;height:10px;display:block;fill:none;stroke:currentColor;}',
    /* Header desktop: el form recortaba el panel (overflow) y el menú quedaba encima */
    '.factory-wh-search .factory-wh-search__submit{border-radius:0 3px 3px 0;}',
    '.factory-wh-header:has(.fs-ps:not([hidden])){z-index:300;}',
    /* Celular: el panel queda sobre el botón flotante de WhatsApp */
    '#fs-msearch:has(.fs-ps:not([hidden])){z-index:2147483000;}',
    '@media (max-width:749px){.fs-ps{position:fixed;left:8px;right:8px;top:var(--fs-ps-top,120px);max-height:calc(100dvh - var(--fs-ps-top,120px) - 12px);}}'
  ].join('');
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML.split('"').join('&quot;');
  }
  function highlight(text, q) {
    /* Pone en negrita las palabras buscadas (sin expresiones regulares) */
    var words = q.toLowerCase().split(' ').filter(function (w) { return w.length > 1; });
    var low = String(text).toLowerCase(), marks = [];
    words.forEach(function (w) {
      var i = low.indexOf(w);
      while (i > -1) { marks.push([i, i + w.length]); i = low.indexOf(w, i + w.length); }
    });
    marks.sort(function (x, y) { return x[0] - y[0]; });
    var out = '', pos = 0;
    marks.forEach(function (m) {
      if (m[0] < pos) return;
      out += esc(text.slice(pos, m[0])) + '<mark>' + esc(text.slice(m[0], m[1])) + '</mark>';
      pos = m[1];
    });
    return out + esc(text.slice(pos));
  }
  function money(v) {
    return '$' + Math.round(Number(v) || 0).toLocaleString('es-CL');
  }
  function img(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  function searchUrl(q) {
    return root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&type=product';
  }

  function fetchResults(q) {
    if (cache[q]) return Promise.resolve(cache[q]);
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,vendor,product_type,variants.sku,tag';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { cache[q] = (d.resources && d.resources.results) || {}; return cache[q]; });
  }

  function render(panel, q, res) {
    var html = '';
    var queries = (res.queries || []).filter(function (x) { return x.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 4);
    var cols = (res.collections || []).slice(0, 4);
    var prods = (res.products || []).slice(0, 6);

    if (queries.length || cols.length) {
      html += '<div class="fs-ps__chips" style="padding-top:12px">';
      queries.forEach(function (x) {
        html += '<a class="fs-ps__chip" data-fs-ps-item href="' + esc(searchUrl(x.text)) + '">' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>' +
          '<span>' + (x.styled_text || esc(x.text)).split('<mark>').join('<b>').split('</mark>').join('</b>') + '</span></a>';
      });
      cols.forEach(function (c) {
        html += '<a class="fs-ps__chip" data-fs-ps-item href="' + esc(c.url) + '"><b>' + esc(c.title) + '</b> →</a>';
      });
      html += '</div>';
    }

    if (prods.length) {
      html += '<div class="fs-ps__h">Productos</div>';
      prods.forEach(function (p) {
        var cmp = Number(p.compare_at_price_max) || 0, price = Number(p.price) || 0;
        var off = cmp > price ? Math.round((1 - price / cmp) * 100) : 0;
        var im = (p.featured_image && p.featured_image.url) || p.image;
        html += '<a class="fs-ps__prod" data-fs-ps-item href="' + esc(p.url) + '">' +
          (im ? '<img class="fs-ps__img" src="' + esc(img(im)) + '" alt="" decoding="async" width="52" height="52">' : '<span class="fs-ps__img"></span>') +
          '<span>' + (p.vendor ? '<span class="fs-ps__v">' + esc(p.vendor) + '</span>' : '') +
          '<span class="fs-ps__t">' + highlight(p.title, q) + '</span>' +
          (p.available ? '' : '<span class="fs-ps__out">Agotado</span>') + '</span>' +
          '<span class="fs-ps__p">' + money(price) + (off > 0 ? '<em>-' + off + '%</em><s>' + money(cmp) + '</s>' : '') + '</span></a>';
      });
      html += '<a class="fs-ps__all" data-fs-ps-item href="' + esc(searchUrl(q)) + '"><span>Ver todos los resultados de “' + esc(q) + '”</span><span aria-hidden="true">→</span></a>';
    } else {
      html += '<div class="fs-ps__empty">No encontramos productos para “' + esc(q) + '”. Prueba con otra palabra o ' +
        '<a href="https://wa.me/56932704588?text=' + encodeURIComponent('Hola, estoy buscando: ' + q) + '" target="_blank" rel="noopener">pregúntanos por WhatsApp</a>.</div>';
    }
    panel.innerHTML = html;
  }

  function attach(input) {
    if (input.dataset.fsPs) return;
    input.dataset.fsPs = '1';
    var form = input.form || input.closest('form');
    if (!form) return;
    form.classList.add('fs-ps-host');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    var panel = document.createElement('div');
    panel.className = 'fs-ps';
    panel.id = 'fs-ps-' + Math.random().toString(36).slice(2, 8);
    panel.hidden = true;
    form.appendChild(panel);
    input.setAttribute('aria-controls', panel.id);

    /* Botón "borrar": aparece apenas hay texto y deja el cursor listo para escribir de nuevo */
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'fs-ps-clear';
    clear.setAttribute('aria-label', 'Borrar búsqueda');
    clear.innerHTML = '<span><svg viewBox="0 0 12 12" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8"/></svg></span>';
    clear.hidden = !input.value;
    input.insertAdjacentElement('afterend', clear);
    function syncClear() { clear.hidden = !input.value; }

    var timer, seq = 0, active = -1;

    function place() {
      /* En celular el panel es fijo bajo el buscador (el header puede ser sticky) */
      var r = form.getBoundingClientRect();
      panel.style.setProperty('--fs-ps-top', Math.max(8, Math.round(r.bottom + 6)) + 'px');
    }
    function open() { place(); panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function close() { panel.hidden = true; active = -1; input.setAttribute('aria-expanded', 'false'); }
    function items() { return panel.querySelectorAll('[data-fs-ps-item]'); }
    function setActive(i) {
      var list = items();
      if (!list.length) return;
      active = (i + list.length) % list.length;
      list.forEach(function (el, k) { el.classList.toggle('is-active', k === active); });
      list[active].scrollIntoView({ block: 'nearest' });
    }

    function run() {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      var my = ++seq;
      fetchResults(q).then(function (res) {
        if (my !== seq || input.value.trim() !== q) return;
        render(panel, q, res);
        active = -1;
        open();
      }).catch(function () { /* si falla, el formulario normal sigue funcionando */ });
    }

    clear.addEventListener('click', function () {
      clearTimeout(timer);
      seq++;
      input.value = '';
      syncClear();
      close();
      input.focus();
    });

    input.addEventListener('input', function () { syncClear(); clearTimeout(timer); timer = setTimeout(run, 160); });
    input.addEventListener('focus', function () { syncClear(); if (input.value.trim().length >= 2) run(); });
    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); items()[active].click(); }
    });
    document.addEventListener('pointerdown', function (e) { if (!form.contains(e.target)) close(); });
    window.addEventListener('resize', function () { if (!panel.hidden) place(); });
    window.addEventListener('scroll', function () { if (!panel.hidden) place(); }, { passive: true });
  }

  function init() { document.querySelectorAll(SELECTOR).forEach(attach); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* El header de Horizon puede re-renderizarse: se vuelve a enganchar */
  var pend;
  new MutationObserver(function () { if (pend) return; pend = requestAnimationFrame(function () { pend = 0; init(); }); }).observe(document.body, { childList: true, subtree: true });
})();